import get from 'lodash.get';

const getSocialIcons = (rootState) => get(rootState, 'ws.template.meta.socialIcons', {});

export default getSocialIcons;
